<template>
	<div class="sign">
		<div class="sign-header"><img :src="product.picture" alt=""></div>
		<div class="sign-body">
			<div class="sign-title">{{product.name}}</div>
			<div class="sign-content" v-html="product.intro"></div>
		</div>
		<div class="footer">
			<div class="mvbutton btn" @click="show=true">立即报名</div>
		</div>
		<van-action-sheet v-model="show" title="请选择您要报考的证书类型">
			<div class="content">

				<van-radio-group v-model="skuid" @change="selectItem">
					<van-radio :name="index" v-for="(item,index) in  product.sku" :key="index" class="sku-title">
						{{item.name}}</van-radio>
				</van-radio-group>

			</div>
			<div class="footer">
				<div class="mvbutton btn" @click="jumpUrl">立即报名
<!--					<span class="price" v-if="skuitem">(￥{{skuitem.price}}）</span>-->
				</div>
			</div>
		</van-action-sheet>
	</div>
</template>
<script>
    import {Cell, CellGroup,Field,RadioGroup, Radio,Button,List,ActionSheet,Toast} from 'vant'
    import './index.less'
    import util from 'libs/utils'

    export default {
        name: "baomin",
        components: {
            vanCell:Cell,
            vanCellGroup:CellGroup,
            vanField:Field,
            vanRadioGroup:RadioGroup,
            vanRadio:Radio,
            vanButton:Button,
            List,
			vanActionSheet:ActionSheet,
            Toast
        },
        data() {
            return {
            	  detail:{},
                cat_id:this.$route.query.cat_id?this.$route.query.cat_id:"",
                product:"",
                show:false,
                skuid:"",
                skuitem:'',
                cert_type:''
            }
        },
        methods: {
            getDetail(){
                this.$api.system.getSign({id:1}).then((res)=>{
                    if(res.code==200){
                    	this.detail = res.data
                    }
                })
            },
			getProduct(){
				this.$api.system.getProductDetail({cate_id:this.cat_id}).then((res)=>{
					if(res.code==200){
						this.product = res.data
            // if(this.product.name.indexOf('中级'))
            // {
            //   this.cert_type = 1;
            // }else if(this.product.name.indexOf('教员'))
            // {
            //   this.cert_type = 2;
            // }
					}
				})
			},
            jumpUrl()
			{
//			    this.$router.push({'name':'myinfo'});
				if(!this.skuitem)
				{
                    Toast.fail("请选择要报考的证书");
                    return false;
				}
                this.$router.push({name:'myinfo',query:{skuid:this.skuitem.id,cat_id:this.cat_id,cert_type:this.cert_type}})
			},
      selectItem(e)
			{
			    this.skuitem = this.product.sku[e]
          this.cert_type = e;
			}
        },
        mounted() {
            this.$nextTick(() => {
            	this.getProduct();
            	// this.getDetail()
            })
        }
    }
</script>
